import { PathwayCard } from '@cpd-app/generated';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const pathwayCardsFeatureKey = 'pathwayCards';

export const pathwayCardsStateAdapter: EntityAdapter<PathwayCard> =
  createEntityAdapter<PathwayCard>({
    selectId: (pathway: PathwayCard) => pathway.pathwayId,
    sortComparer: false
  });

export interface PathwayCardsState extends EntityState<PathwayCard> {
  loading: boolean;
}

export const initialPathwayCardsState: PathwayCardsState =
  pathwayCardsStateAdapter.getInitialState({
    loading: false
  });

export const { selectAll, selectEntities, selectIds, selectTotal } =
  pathwayCardsStateAdapter.getSelectors();
